var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePreviewClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72732 5.33301L8.00065 7.05967L6.27398 5.33301L5.33398 6.27301L7.06065 7.99967L5.33398 9.72634L6.27398 10.6663L8.00065 8.93967L9.72732 10.6663L10.6673 9.72634L8.94065 7.99967L10.6673 6.27301L9.72732 5.33301ZM8.00065 1.33301C4.31398 1.33301 1.33398 4.31301 1.33398 7.99967C1.33398 11.6863 4.31398 14.6663 8.00065 14.6663C11.6873 14.6663 14.6673 11.6863 14.6673 7.99967C14.6673 4.31301 11.6873 1.33301 8.00065 1.33301ZM8.00065 13.333C5.06065 13.333 2.66732 10.9397 2.66732 7.99967C2.66732 5.05967 5.06065 2.66634 8.00065 2.66634C10.9407 2.66634 13.334 5.05967 13.334 7.99967C13.334 10.9397 10.9407 13.333 8.00065 13.333Z",
    fill: "#CECFD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePreviewClose);
export default __webpack_public_path__ + "static/media/file-preview-close.d0980a68f90435ab9db707695cabc9cf.svg";
export { ForwardRef as ReactComponent };